module.exports = __webpack_public_path__ + "img/stock5.d64b17e8.png";